import GalleryController from "./GalleryController";
import GalleryFallback from "./GalleryViewerFallback";
export default GalleryController;
export { GalleryFallback };
